

{
  "familyId": "TAA-ONT-BIJZIN",
  "questions": [
    {
      "id": "TAA-ONT-BIJZIN-001",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "multiple_choice",
      "question": "Lees: 'Hoewel het hard regende, gingen de kinderen naar buiten omdat de pauze begon.' Welk deel is de tweede bijzin?",
      "options": ["omdat de pauze begon", "Hoewel het hard regende", "gingen de kinderen naar buiten", "naar buiten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Bijzinnen lokaliseren in samengestelde zinnen", "content": "Vind alle onderschikkende voegwoorden ('hoewel', 'omdat'). De TWEEDE bijzin is degene die later in de zin staat: 'omdat de pauze begon'. Check: persoonsvorm 'begon' staat aan het eind van de bijzin.", "icon": "lightbulb"}}],
      "conceptId": "bijzin_lokaliseren_samengesteld",
      "variantIndex": 1,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.bijzin.hoofdzin.verward", "label": "Kiest de eerste bijzin i.p.v. de tweede", "optionIndex": 1 },
          { "id": "taa.bijzin.hoofdzin.meegeteld", "label": "Telt de hoofdzin als bijzin", "optionIndex": 2 },
          { "id": "taa.bijzin.bepaling.verward", "label": "Verwart bijwoordelijke bepaling met bijzin", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Er staan twee bijzinnen in deze samengestelde zin: 'Hoewel het hard regende' (bijzin 1, voegwoord 'hoewel') en 'omdat de pauze begon' (bijzin 2, voegwoord 'omdat'). De vraag vraagt naar de TWEEDE bijzin → 'omdat de pauze begon'. Persoonsvorm 'begon' staat aan het eind.",
        "solutionSteps": [
          "Zoek alle onderschikkende voegwoorden: 'hoewel' en 'omdat'",
          "Eerste bijzin (vooraan): 'Hoewel het hard regende'",
          "Hoofdzin (midden): 'gingen de kinderen naar buiten'",
          "Tweede bijzin (achteraan): 'omdat de pauze begon'"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Omdat de pauze begon' is de tweede bijzin in de zin.",
          "1": "Dit is wel een bijzin, maar de EERSTE bijzin. De vraag vroeg om de tweede.",
          "2": "'Gingen de kinderen naar buiten' is de hoofdzin (geen voegwoord, kan zelfstandig bestaan).",
          "3": "'Naar buiten' is een bijwoordelijke bepaling van plaats, geen bijzin. Een bijzin heeft een eigen persoonsvorm."
        }
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-002",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "multiple_choice",
      "question": "In welke zin is het cursieve voegwoord ONDERSCHIKKEND (en leidt het dus een bijzin in)?",
      "options": [
        "Ik blijf thuis *terwijl* mijn broer naar voetbal gaat.",
        "Ik wil naar de film, *maar* mijn moeder zegt nee.",
        "Het regent hard, *dus* we nemen de bus.",
        "Hij is moe, *want* hij heeft slecht geslapen."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Onderschikkend herkennen in een zin", "content": "Test: kan de zin na het voegwoord zelfstandig bestaan? Als nee (woordvolgorde verandert, pv naar achteren) → onderschikkend. 'Terwijl mijn broer naar voetbal gaat' is geen complete zin op zich → onderschikkend = bijzin.", "icon": "lightbulb"}}],
      "conceptId": "onderschikkend_in_context",
      "variantIndex": 2,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.bijzin.voegw.maar.onderschikkend", "label": "Verwart 'maar' (nevenschikkend) met onderschikkend", "optionIndex": 1 },
          { "id": "taa.bijzin.voegw.en.onderschikkend", "label": "Verwart 'dus' (nevenschikkend) met onderschikkend", "optionIndex": 2 },
          { "id": "taa.bijzin.voegw.want.omdat.verward", "label": "Verwart 'want' (nevenschikkend) met 'omdat' (onderschikkend)", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "'Terwijl' is onderschikkend: 'terwijl mijn broer naar voetbal gaat' is afhankelijk van de hoofdzin (let op: pv 'gaat' aan het eind). 'Maar', 'dus' en 'want' zijn nevenschikkend — ze verbinden twee zelfstandige hoofdzinnen.",
        "solutionSteps": [
          "Test 1: kan het deel na het voegwoord zelfstandig bestaan?",
          "Test 2: staat de persoonsvorm aan het eind?",
          "'Terwijl' → ja afhankelijk + pv aan eind → onderschikkend"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Terwijl' is onderschikkend (let op pv 'gaat' aan het eind).",
          "1": "'Maar' is nevenschikkend. 'Mijn moeder zegt nee' kan zelfstandig bestaan — dat is een hoofdzin, geen bijzin.",
          "2": "'Dus' is nevenschikkend. 'We nemen de bus' kan zelfstandig bestaan.",
          "3": "'Want' is nevenschikkend, hoewel het net als 'omdat' een reden geeft. Test: 'hij heeft slecht geslapen' is een zelfstandige zin — hoofdzin, geen bijzin."
        }
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-003",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "multiple_choice",
      "question": "Hoeveel bijzinnen heeft deze zin? 'Als het mooi weer is, gaan we naar het strand dat dichtbij ligt omdat we geen zin hebben om ver te rijden.'",
      "options": ["3", "2", "4", "1"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Bijzinnen tellen in lange zinnen", "content": "Tel de onderschikkende voegwoorden: 'als', 'dat', 'omdat'. Dat zijn 3 voegwoorden → 3 bijzinnen. ('Om te rijden' is een beknopte bijzin zonder pv en telt hier niet mee.)", "icon": "lightbulb"}}],
      "conceptId": "bijzinnen_tellen_complex",
      "variantIndex": 3,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.bijzin.tellen.eentje.gemist", "label": "Mist één van de drie voegwoorden", "optionIndex": 1 },
          { "id": "taa.bijzin.hoofdzin.meegeteld", "label": "Telt de hoofdzin mee als bijzin", "optionIndex": 2 },
          { "id": "taa.bijzin.geen.herkend", "label": "Herkent slechts één bijzin", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Er zijn 3 bijzinnen: 1) 'als het mooi weer is' (voegwoord 'als'), 2) 'dat dichtbij ligt' (voegwoord 'dat'), 3) 'omdat we geen zin hebben...' (voegwoord 'omdat'). De hoofdzin is 'gaan we naar het strand'.",
        "solutionSteps": [
          "Voegwoord 1: 'als' → bijzin 1",
          "Voegwoord 2: 'dat' → bijzin 2",
          "Voegwoord 3: 'omdat' → bijzin 3",
          "Totaal: 3 bijzinnen"
        ],
        "distractorExplanations": {
          "0": "Goed! Drie bijzinnen, ingeleid door 'als', 'dat', 'omdat'.",
          "1": "Je miste één voegwoord. Kijk goed: 'als', 'dat' EN 'omdat' zijn alle drie onderschikkend.",
          "2": "Je telde 4, maar de hoofdzin 'gaan we naar het strand' is geen bijzin (geen voegwoord).",
          "3": "Je telde 1. Maar er zijn drie aparte onderschikkende voegwoorden, en elke leidt een bijzin in."
        }
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-004",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "multiple_choice",
      "question": "Welke uitspraak over bijzinnen is JUIST?",
      "options": [
        "Een bijzin heeft een eigen persoonsvorm, die altijd aan het eind van de bijzin staat.",
        "Een bijzin is altijd korter dan de hoofdzin.",
        "Een bijzin staat altijd na de hoofdzin.",
        "Een bijzin heeft nooit een eigen onderwerp."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Eigenschappen van een bijzin", "content": "Een bijzin: (1) begint met onderschikkend voegwoord, (2) heeft eigen onderwerp + persoonsvorm, (3) pv aan het eind. Lengte en positie zijn geen kenmerken.", "icon": "lightbulb"}}],
      "conceptId": "bijzin_eigenschappen_evalueren",
      "variantIndex": 4,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.bijzin.lengte.criterium", "label": "Denkt dat lengte een criterium is", "optionIndex": 1 },
          { "id": "taa.bijzin.positie.criterium", "label": "Denkt dat positie een criterium is", "optionIndex": 2 },
          { "id": "taa.bijzin.pv.verward", "label": "Denkt dat bijzin geen onderwerp heeft", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Een bijzin heeft altijd een eigen persoonsvorm die aan het eind staat (bv. 'omdat het hard regende' — pv 'regende' aan het eind). Lengte en positie maken niet uit, en een bijzin heeft wél een eigen onderwerp.",
        "solutionSteps": [
          "Bijzin = voegwoord + onderwerp + ... + pv (aan eind)",
          "Lengte = niet relevant",
          "Positie = niet relevant (kan vooraan of achteraan staan)",
          "Eigen onderwerp = ja, altijd"
        ],
        "distractorExplanations": {
          "0": "Goed! Persoonsvorm aan het eind is hét kenmerk van een bijzin.",
          "1": "Lengte is geen criterium. Een bijzin kan langer zijn dan de hoofdzin.",
          "2": "Positie is geen criterium. 'Omdat het regent, blijf ik thuis' — bijzin vooraan.",
          "3": "Een bijzin heeft wél een eigen onderwerp. In 'omdat HIJ ziek is' is 'hij' het onderwerp van de bijzin."
        }
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-005",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "fill_in",
      "question": "Vul een onderschikkend voegwoord in dat een TIJDSBEPALING aangeeft: 'Ik wachtte ... mijn vriend eindelijk aankwam.'",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["totdat", "tot", "voordat", "tot dat"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Voegwoorden voor tijd", "content": "Onderschikkende voegwoorden die TIJD aangeven: totdat, voordat, nadat, terwijl, zodra, wanneer. 'Ik wachtte TOTDAT/VOORDAT mijn vriend aankwam.'", "icon": "lightbulb"}}],
      "conceptId": "bijzin_voegwoord_tijd_fill",
      "variantIndex": 5,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.bijzin.voegw.want.omdat.verward", "label": "Kiest een reden-voegwoord (omdat/want) i.p.v. tijd-voegwoord" },
          { "id": "taa.bijzin.voegw.en.onderschikkend", "label": "Kiest een nevenschikkend voegwoord (en/maar/dus)" }
        ]
      },
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De bijzin geeft een tijdsbepaling: WANNEER eindigde het wachten? Passende voegwoorden: 'totdat', 'voordat', of 'tot'. Niet: 'omdat' (reden), 'als' (voorwaarde), of 'maar' (nevenschikkend).",
        "solutionSteps": [
          "De bijzin moet tijd aangeven",
          "Tijd-voegwoorden: totdat, voordat, nadat, terwijl",
          "Niet: omdat (reden), als (voorwaarde)"
        ]
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-006",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "text_highlight",
      "question": "Markeer alleen de bijzin die een REDEN aangeeft (let op: er staat ook een tijds-bijzin in de zin!).",
      "data": {
        "text": "De leerling ging naar huis omdat hij zich niet lekker voelde, terwijl zijn klasgenoten nog les hadden.",
        "correctHighlight": "omdat hij zich niet lekker voelde",
        "highlightUnit": "clause"
      },
      "correctAnswer": "omdat hij zich niet lekker voelde",
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Functie van bijzinnen", "content": "Niet elk voegwoord geeft hetzelfde aan. 'Omdat' = reden, 'terwijl' = tijd. Hier zijn twee bijzinnen — de vraag vraagt naar de REDEN, dus de 'omdat'-bijzin.", "icon": "lightbulb"}}],
      "conceptId": "bijzin_highlight_functie",
      "variantIndex": 6,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.bijzin.voegw.want.omdat.verward", "label": "Markeert de tijds-bijzin i.p.v. de reden-bijzin" },
          { "id": "taa.bijzin.hoofdzin.verward", "label": "Markeert de hoofdzin" }
        ]
      },
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Er staan twee bijzinnen in deze zin. 'Omdat hij zich niet lekker voelde' geeft een REDEN (waarom ging hij naar huis?). 'Terwijl zijn klasgenoten nog les hadden' geeft een TIJD aan (wanneer ging hij?). De vraag vroeg om de reden-bijzin.",
        "solutionSteps": [
          "Zoek alle onderschikkende voegwoorden: 'omdat' en 'terwijl'",
          "Bepaal functie: 'omdat' = reden, 'terwijl' = tijd",
          "Vraag = reden → markeer 'omdat hij zich niet lekker voelde'"
        ]
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-007",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "text_highlight",
      "question": "Deze zin heeft twee bijzinnen. Markeer de bijzin die een VOORWAARDE aangeeft.",
      "data": {
        "text": "Als je je huiswerk af hebt, mag je buiten spelen totdat het donker wordt.",
        "correctHighlight": "Als je je huiswerk af hebt",
        "highlightUnit": "clause"
      },
      "correctAnswer": "Als je je huiswerk af hebt",
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Soorten bijzinnen", "content": "Er zijn twee bijzinnen: 'Als je je huiswerk af hebt' (voorwaarde — voegwoord 'als') en 'totdat het donker wordt' (tijdsbepaling — voegwoord 'totdat'). De vraag vraagt naar de VOORWAARDE, dus de bijzin met 'als'.", "icon": "lightbulb"}}],
      "conceptId": "bijzin_highlight_voorwaarde",
      "variantIndex": 7,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.bijzin.voegw.want.omdat.verward", "label": "Markeert de tijds-bijzin i.p.v. de voorwaarde-bijzin" },
          { "id": "taa.bijzin.hoofdzin.verward", "label": "Markeert de hoofdzin" }
        ]
      },
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Er zijn twee bijzinnen in deze zin. 'Als je je huiswerk af hebt' geeft een voorwaarde aan (voegwoord 'als'). 'Totdat het donker wordt' geeft een tijdsbepaling aan (voegwoord 'totdat'). De vraag vraagt naar de voorwaarde, dus 'Als je je huiswerk af hebt' is het juiste antwoord.",
        "solutionSteps": [
          "Zoek alle onderschikkende voegwoorden: 'als' en 'totdat'",
          "Bepaal de functie: 'als' = voorwaarde, 'totdat' = tijdsbepaling",
          "De voorwaarde-bijzin is: 'Als je je huiswerk af hebt'"
        ]
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-008",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "ordering",
      "question": "Zet de woorden in de juiste volgorde zodat er een correcte bijzin ontstaat. Let op: persoonsvorm aan het eind, en denk aan de werkwoordstijd.",
      "data": {
        "items": ["omdat", "de trein", "naar Amsterdam", "te laat", "was vertrokken"],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "correctAnswer": "omdat de trein naar Amsterdam te laat was vertrokken",
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Woordvolgorde in bijzinnen", "content": "In een bijzin staat de werkwoordsgroep aan het EIND. De volgorde is: voegwoord + onderwerp + bepalingen + persoonsvorm + (deelwoord). Werkwoordelijke groepen blijven bij elkaar: 'was vertrokken' aan het eind.", "icon": "lightbulb"}}],
      "conceptId": "bijzin_woordvolgorde_complex",
      "variantIndex": 8,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.bijzin.pv.verward", "label": "Persoonsvorm niet aan het eind geplaatst" },
          { "id": "taa.bijzin.zonder.voegwoord", "label": "Voegwoord niet vooraan geplaatst" }
        ]
      },
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "In een bijzin staat de werkwoordsgroep aan het eind. Volgorde: voegwoord (omdat) + onderwerp (de trein) + bepaling (naar Amsterdam) + bepaling (te laat) + werkwoordsgroep (was vertrokken). Vergelijk met hoofdzin: 'De trein was te laat naar Amsterdam vertrokken'.",
        "solutionSteps": [
          "Voegwoord vooraan: 'omdat'",
          "Onderwerp: 'de trein'",
          "Bepalingen: 'naar Amsterdam', 'te laat'",
          "Werkwoordsgroep helemaal aan het eind: 'was vertrokken'"
        ]
      }
    }
  ]
}

